<!--Title Bar-->
<div class="groups-PopupHeader">
	<h2>View Event Scan Details</h2>
</div>
<!--Details Part 1-->
<div class="groups-ViewDetailsSubMenuTop">
	<!--Event Short Description-->
	<label>Event Short Description:</label>
	<label>{{ selectedDetails.EventDescShort }}</label>

	<!--Event Long Description-->
	<label>Event Long Description:</label>
	<label>{{ selectedDetails.EventDescLong }}</label>

	<!--Event Location-->
	<label>Event Location:</label>
	<label>{{ selectedDetails.EventLocation }}</label>
</div>

<!--Details Part 2-->
<div class="groups-ViewDetailsSubMenu">
	<!--Student ID-->
	<label>Student ID:</label>
	<label>{{ selectedDetails.StudentID }}</label>

	<!--Student Name-->
	<label>Student Name:</label>
	<label>{{ selectedDetails.StudentName }}</label>

	<!--Scan Result-->
	<label>Scan Result:</label>
	<label>{{ selectedDetails.ScanResult }}</label>

	<!--Scan Date/Time-->
	<label>Scan Date/Time:</label>
	<label>{{ selectedDetails.ScanDateTime }}</label>

	<!--Scan Sation Entered At-->
	<label>Scan Station:</label>
	<label>{{ selectedDetails.ScanStation }}</label>
</div>

<!--Buttons-->
<div class="groups-PopupButtons">
	<!--Close-->
	<button class="btn btn-primary groups-ButtonSpacing" (click)="CancelViewDetailsClick()">Close</button>
</div>
